module.exports = __webpack_public_path__ + "media/images/gifts/music/sug_musica_1-bbaa34549efeb8a87828ad0b24c64eaa.jpg";